import MuiBaseModal from "../../common/modal/MuiModal";
import CreateBlocknumbersForm from "../../../forms/block-numbers-create-edit/CreateblockNumbersForm";
import { IBlockNumberSchema } from "../../../services/Schemas/BlockNumber";

interface ICreateRole {
  onClose: (payload: boolean) => void;
  handleReload?: () => void;
  blockNumber?: Partial<IBlockNumberSchema>;
  open: boolean;
}

export default function CreateblockNumbersModal({
  onClose,
  open,
  blockNumber,
  handleReload,
}: ICreateRole) {
  return (
    <MuiBaseModal
      open={open}
      onClose={() => onClose(false)}
      title={blockNumber ? "ویرایش شماره بلاک شده" : "ایجاد شماره بلاک شده"}
      hasCloseIcon
    >
      <CreateBlocknumbersForm
        blockNumber={blockNumber}
        onSuccess={() => {
          onClose(false);
          handleReload && handleReload();
        }}
      />
    </MuiBaseModal>
  );
}
